import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.addMsg();
      }
    }
  }, [_vm._v(" 添加一行api信息 ")])], 1), _c("el-form", [_vm.config ? _c("el-table", {
    attrs: {
      data: _vm.config,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      align: "center",
      label: "api名称",
      width: "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-form-item", [_c("el-input", {
          model: {
            value: scope.row.name,
            callback: function callback($$v) {
              _vm.$set(scope.row, "name", $$v);
            },
            expression: "scope.row.name"
          }
        })], 1)];
      }
    }], null, false, 3367355886)
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "请求method",
      width: "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-form-item", [_c("el-select", {
          attrs: {
            placeholder: "请选择"
          },
          model: {
            value: scope.row.method,
            callback: function callback($$v) {
              _vm.$set(scope.row, "method", $$v);
            },
            expression: "scope.row.method"
          }
        }, _vm._l(_vm.options, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: {
              label: item.label,
              value: item.value
            }
          });
        }), 1)], 1)];
      }
    }], null, false, 2319079235)
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "是否需要记录日志",
      width: "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-form-item", [_c("el-switch", {
          attrs: {
            "active-value": 1,
            "inactive-value": 0
          },
          model: {
            value: scope.row.isLog,
            callback: function callback($$v) {
              _vm.$set(scope.row, "isLog", $$v);
            },
            expression: "scope.row.isLog"
          }
        }), _vm._v(" " + _vm._s(scope.row.isLog === 0 ? "否" : "是") + " ")], 1)];
      }
    }], null, false, 13133087)
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "是否远程调用(需要后台转发请求)",
      width: "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-form-item", [_c("el-switch", {
          attrs: {
            "active-value": 1,
            "inactive-value": 0
          },
          model: {
            value: scope.row.isRemoteCall,
            callback: function callback($$v) {
              _vm.$set(scope.row, "isRemoteCall", $$v);
            },
            expression: "scope.row.isRemoteCall"
          }
        }), _vm._v(" " + _vm._s(scope.row.isRemoteCall === 0 ? "否" : "是") + " ")], 1)];
      }
    }], null, false, 1577497919)
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "api的url"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-form-item", {
          attrs: {
            required: true
          }
        }, [_c("el-input", {
          model: {
            value: scope.row.url,
            callback: function callback($$v) {
              _vm.$set(scope.row, "url", $$v);
            },
            expression: "scope.row.url"
          }
        })], 1)];
      }
    }], null, false, 3777110321)
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "操作",
      width: "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-form-item", [_c("el-button", {
          attrs: {
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.delBtn(scope.$index);
            }
          }
        }, [_vm._v("删除")])], 1)];
      }
    }], null, false, 3738696182)
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };